'use client';

import { breakpointValues } from '@/theme/breakpoint';

export const breakpoints = {
  phone: breakpointValues.smValue,
  tablet: breakpointValues.mdValue,
  desktop: breakpointValues.lgValue,
} as const;

export const media = (query: string) => {
  const isMax = query.startsWith('<');
  const key = query.replace(/^[<>]=?/, '') as keyof typeof breakpoints;
  const px = breakpoints[key];
  return isMax
    ? `@media (max-width: ${px - 1}px)`
    : `@media (min-width: ${px + 1}px)`;
};
